import withAuthHeader from '../../utils/withAuthHeader';

import { mapFetchAccessControlResponse } from '../mappers/access-control';

export const actionTypes = {
  SET_ACCESS_CONTROL: 'SET_ACCESS_CONTROL'
};

export const fetchUserAccessControl = () => async (dispatch, getState, api) => {
  let result = {};
  try {
    const url = `api/v1/dashboard/perfilacesso`;
    const apiResponse = await api.get(url, {
      ...withAuthHeader()
    });
    const response = mapFetchAccessControlResponse(apiResponse.data);
    result = {
      success: true,
      data: response
    };
    dispatch({
      type: actionTypes.SET_ACCESS_CONTROL,
      payload: response
    });
  } catch (e) {
    result = {
      error: e.message
    };
  }
  return result;
};
